import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { useEffect, useRef, useState } from 'react'
import useVerEstoque, { LOAD_MESSAGE } from './VerEstoqueHook'
import {
  Btn,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { Dropdown } from 'primereact/dropdown'
import { isRouteAllowed } from '../../../../services/permission/menus'
import ModalEditarPosicao from './ModalEditarPosicao'

function VerEstoque({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useVerEstoque()
  const [showModal, setShowModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const hasPermission = isRouteAllowed(49)

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.PRODUTOS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getProdutosOnPosicao(selectedTp, state.selectedEstoque.id)
        break

      case LOAD_MESSAGE.POSICOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPosicoesEstoque(selectedTp, state.selectedEstoque.id)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // function TrueOrFalseIconSetter(value) {
  //   if (value) return <i className="pi pi-check"></i>
  //   else return <i className="pi pi-times"></i>
  // }

  let dt = useRef(null)

  const companyFilter = (
    <Dropdown
      style={{ width: '100%' }}
      placeholder="Filtrar por Empresa"
      value={state.selectedEmpresa}
      options={state.empresas}
      onChange={ev => localDispatch.onChangeEmpresa(dt, ev)}
      showClear
    />
  )

  function typePorPosicao(type) {
    if (type === 'Por Posição')
      return (
        <div className="p-col-3">
          <CustomDropdown
            filter={true}
            placeholder="Selecione uma Posicao"
            optionLabel={'label'}
            options={state.posicoes}
            label={'Posição de Estoque'}
            onChange={value => localDispatch.onChange('selectedPosicao', value)}
            value={state.selectedPosicao}
            showClear
          />
        </div>
      )
  }

  const handleThreeDotsClick = (item, action) => {
    if (action === 'Editar') {
      setSelectedItem(item)
      setShowModal(true)
    }
  }

  const handleModalSave = data => {
    localDispatch.updatePosicaoItem(selectedTp, selectedItem.id, data)
    setShowModal(false)
    setSelectedItem(null)
  }

  const handleModalClose = () => {
    setShowModal(false)
    setSelectedItem(null)
  }

  const actionsBodyTemplate = rowData => {
    if (!hasPermission) return null
    return (
      <div style={{ textAlign: 'center' }}>
        <ThreeDots items={['Editar']} onClick={action => handleThreeDotsClick(rowData, action)} />
      </div>
    )
  }

  return (
    <div>
      <PageHeader>8.7 - Relatório de Posição de Estoque</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                disabled={!selectedTp}
                placeholder="Selecione um Estoque"
                optionLabel={'name'}
                options={state.estoques}
                label={'Estoque'}
                onChange={value => localDispatch.onChange('selectedEstoque', value)}
                value={state.selectedEstoque}
              />
            </div>
            <div className="p-col-3">
              <CustomDropdown
                disabled={!selectedTp}
                placeholder="Tipo de Visualização"
                optionLabel={'label'}
                options={[
                  { label: 'Geral', value: 'Geral' },
                  { label: 'Por Posição', value: 'Por Posição' },
                ]}
                label={'Posição de Estoque'}
                onChange={value => localDispatch.onChange('selectedTypeVisualizer', value)}
                value={state.selectedTypeVisualizer}
              />
            </div>
            {typePorPosicao(state.selectedTypeVisualizer.value)}
          </div>
          <div
            className="p-grid p-justify-center"
            style={{
              margin: '0px 0px',
              padding: '10px',
              borderRadius: '4px',
              height: '100%',
              marginTop: 20,
            }}
          >
            <div className="p-col-12 p-grid p-justify-center" style={{ padding: 0 }}>
              <DataTable
                value={state.produtos}
                header={
                  <CustomDataTableHeader
                    onChange={value => localDispatch.onChange('globalFilter', value)}
                    children={
                      <>
                        <div style={{ display: 'inline-block', marginLeft: '20px' }}>
                          {companyFilter}
                        </div>
                        <div style={{ display: 'inline-block', marginLeft: '20px' }}>
                          <Btn
                            disabled={!selectedTp}
                            onClick={() =>
                              localDispatch.generateExcel(
                                state.produtos,
                                state.selectedEmpresa,
                                state.selectedEstoque,
                              )
                            }
                          >
                            Exportar Produtos
                          </Btn>
                        </div>
                      </>
                    }
                  />
                }
                selection={state.selectedProduto}
                onSelectionChange={e => localDispatch.onChange('selectedProduto', e.value)}
                globalFilter={state.globalFilter}
                paginator={true}
                rows={10}
                ref={dt}
                emptyMessage="Nenhum produto a ser exibido"
              >
                <Column field="endereco" header="Posição" style={tableCellCentered()} />
                <Column field="product_code" header="Código" style={tableCellCentered()} />
                <Column field="name" header="Produto" style={tableCellCentered(200)} />
                <Column field="quantidade" header="Qte" style={tableCellCentered(50)} />
                <Column field="validade" header="Validade" style={tableCellCentered(80)} />
                <Column field="lote" header="Lote" style={tableCellCentered(100)} />
                <Column field="company_name" header="Empresa" style={tableCellCentered(100)} />
                <Column field="pallet_area_id" header="Etiqueta" style={tableCellCentered(100)} />
                <Column
                  field="identifiers"
                  header="Identificador"
                  style={tableCellCentered(150)}
                  body={rowData => rowData.identifiers || '-'}
                />
                {hasPermission && (
                  <Column header="Menu" body={actionsBodyTemplate} style={tableCellCentered(50)} />
                )}
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalEditarPosicao
        show={showModal}
        onClose={handleModalClose}
        onSave={handleModalSave}
        itemData={selectedItem}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(VerEstoque))
